import React, { useEffect } from "react";

import { useState } from "react";
import UserSelect from "../menu/Form/select/UserSelect";
import { Alert, App, Button, Col, Collapse, Divider, Flex, Input, Modal, Row, Select, Typography } from "antd";
import { ArtistRep } from "../../../data/models/artist-rep";
import { DeleteOutlined } from "@ant-design/icons";
import { makeRequest } from "../../helpers/axios-manipulator";
const { Text } = Typography;

type Props = {
    loading: boolean,
    contract: any,
    contracts: Array<ArtistRep>,
    setContracts: Function,
    hasNewContract: boolean,
    index: number,
    setHasNewContract: Function,
}

const ArtistRepresentationContract = ({ loading, contract, contracts, setContracts, hasNewContract, index, setHasNewContract }: Props) => {
    const [artistSelected, setArtistSelected] = useState<any>({ username: contract?.artist_username, id: contract?.artist_id });
    const [unlinkContractModal, setUnlinkContractModal] = useState(false);
    const [freeFee, setFreeFee] = useState(100)
    const initialFee = contract?.fee || 0;
    const [newContract, setNewContract] = useState<ArtistRep>(contract as ArtistRep)
    const [isOpen, setIsOpen] = useState(true);
    const [selectedType, setSelectedType] = useState(contract.rep_type.toString() || "4")
    const { message } = App.useApp();
    const contractTypes = [
        { label: "4 - artwork representation", value: "4" },
        { label: "3 - artist management", value: "3" }
    ]
    const toggleCollapse = () => {
        setIsOpen(!isOpen);
    };

    const saveContract = () => {
        const updatedContracts = contracts?.map(contract => {
            if (contract.artist_id === artistSelected.id || (hasNewContract && contract.id === "")) {
                return {
                    ...contract,
                    ...newContract,
                    rep_id: contract.rep_id,
                    dealer_profile: contract.dealer_profile,
                    dealer_username: contract.dealer_username,
                    artist_username: artistSelected.username,
                    editing: false,
                    artist_id: artistSelected.id,
                    rep_type: parseInt(selectedType),
                };
            }
            return contract;
        });
        setContracts(updatedContracts);
        setHasNewContract(false);
    }
    const cancel = () => {
        let newContracts = [...contracts]

        newContracts[index].editing = false;
        if (hasNewContract) newContracts.splice(index, 1);
        setHasNewContract(false)
        setContracts([...newContracts])

    }
    const deleteContract = async () => {
        let newContracts = [...contracts]
        if (newContracts[index].id === "") {
            newContracts.splice(index, 1);
            return setContracts([...newContracts])
        }
        try {
            const contractsResponse = await makeRequest({
                origin: window.location.origin,
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                url: '/api-update-contract',
                data: { ...contract, status: 'inactive' },
            });
            newContracts.splice(index, 1);
            setContracts([...newContracts])
        } catch (error) {
            message.error('something wrong happened while removing the contract.');
        }
    }
    const allowEdit = (e) => {
        e.stopPropagation();

        if (!isOpen) {
            setIsOpen(true);
        }
        let newContracts = [...contracts]
        newContracts[index].editing = true;
        setContracts([...newContracts])
    }

    const handleFeeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        const parsedValue = Math.max(0, Math.min(freeFee, parseInt(value, 10) || 0));
        setNewContract({ ...newContract, fee: parsedValue });
    };
    const getRelatedContracts = async () => {
        try {
            const response = await makeRequest({
                origin: window.location.origin,
                method: 'get',
                url: `/api-available-contracts/${contract?.artist_id}/1`,
                headers: {},
            });
            const contractsPercent = response.reduce((sum, contract) => sum + contract.fee, 0);
            setFreeFee(100 - contractsPercent + initialFee)
        } catch (error) {

        }
    }

    useEffect(() => {
        getRelatedContracts()
    }, [])

    return (
        <>
            {/* Delete contract Modal */}
            <Modal
                centered
                title="Unlink contract"
                open={unlinkContractModal}
                onOk={deleteContract}
                onCancel={() => setUnlinkContractModal(false)}
                okText="Unlink"
                cancelText="Cancel"
            >
                <p>Are you sure that you want to disable this contract from this user?</p>
            </Modal>
            <Collapse
                className="contract-collapse mt-3"
                activeKey={isOpen ? index : ''}
                defaultActiveKey={isOpen ? index : ''} onChange={toggleCollapse}
                collapsible='header'
                style={{ alignItems: 'center' }}
                items={[
                    {
                        key: index,
                        label: <Row gutter={8} style={{ alignItems: 'center' }}>
                            <Col flex="auto">
                                <Divider className="my-0" orientation="left" orientationMargin="0">{Object.keys(artistSelected).length > 1 ? `${artistSelected.username} ` : `Dealer ${index + 1}`}</Divider>
                            </Col>
                            {!contract.editing ?
                                <Col flex="116px">
                                    <Button
                                        className='mt-0'
                                        type="primary" onClick={allowEdit}>Edit contract</Button>
                                </Col> :
                                <Button className="mr-3" onClick={() => setUnlinkContractModal(true)} type="primary" danger title="Artist contract">
                                    <DeleteOutlined />
                                </Button>
                            }
                        </Row>,
                        children:
                            <>
                                {freeFee < 100 && <Alert className="m-auto mb-4" style={{ width: 'fit-content' }} message={`this artist has ${100 - freeFee}% of his representation compromised by other contracts`} type="info" />}
                                <UserSelect update={loading} className='mb-5' setData={setArtistSelected} data={artistSelected} selectedUser={artistSelected.username} route="/api-users?type=1" disableField={!contract.editing} />
                                {
                                    Object.keys(artistSelected).length > 1 &&
                                    <>
                                        <Row gutter={8}>
                                            <Col span={24} md={12}>
                                                <Text>commission value % {freeFee < 100 && `(max ${freeFee}%)`}</Text>
                                                <Input
                                                    type="number"
                                                    min={0}
                                                    max={freeFee}
                                                    disabled={(artistSelected && Object.keys(artistSelected).length === 0) || !contract.editing}
                                                    className='mb-5' value={newContract?.fee || ''}
                                                    onChange={handleFeeChange}
                                                    placeholder="Ex: 10" />
                                            </Col>
                                            <Col span={24} md={12}>
                                                <Text>Contract type</Text>
                                                <Select
                                                    disabled={!contract.editing}
                                                    placeholder="Select contract type"
                                                    style={{ width: '100%' }}
                                                    defaultValue={selectedType}
                                                    onChange={(e) => setSelectedType(e)}
                                                    options={contractTypes}
                                                />
                                            </Col>
                                        </Row>
                                        {contract?.editing &&
                                            <Flex gap="middle" align="start" vertical>
                                                <Flex className='w-full' justify="space-between" align="center">
                                                    <div>
                                                        <Button danger onClick={cancel}>
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                    <Button
                                                        className='mt-4'
                                                        onClick={saveContract}
                                                        type="primary">Save contract</Button>
                                                </Flex>
                                            </Flex>
                                        }
                                    </>
                                }
                            </>
                        ,
                    },
                ]}
            />

        </>
    )
};


export default ArtistRepresentationContract;